import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { onConsentChange } from "@/lib/consent";
import { syncConsentWithdrawal, trackStudioPageView } from "@/lib/studioPixel";
import { useCognitoAuth } from "@/hooks/useCognitoAuth";

/**
 * Also carries a "no" to the server for a signed-in Studio user (lib/studioPixel syncConsentWithdrawal): at once when
 * the banner's choice becomes "no", and once per session on a Studio admin page when the stored choice is "no".
 *
 * The Studio Meta pixel's PageView on photohawk.com's marketing, sign-up and Studio admin pages — only once the
 * visitor accepted analytics/advertising cookies (lib/studioPixel.ts checks consent and the page every time).
 * Renders nothing; client-only (effects never run during SSR).
 */
const StudioPixel = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useCognitoAuth();

  useEffect(() => {
    trackStudioPageView();
  }, [pathname]);

  // Accepting in the banner counts the page the visitor is on; saying no is sent to the server straight away.
  useEffect(() => onConsentChange((s) => {
    if (s.analytics) trackStudioPageView();
    else syncConsentWithdrawal({ signedIn: isAuthenticated, force: true });
  }), [isAuthenticated]);

  // A Studio admin page with a stored "no": make sure the server knows (once per session).
  const onAdmin = pathname === "/admin" || pathname.startsWith("/admin/");
  useEffect(() => {
    if (onAdmin) syncConsentWithdrawal({ signedIn: isAuthenticated });
  }, [onAdmin, isAuthenticated]);

  return null;
};

export default StudioPixel;
